// Centralized styles for readability

export const containerStyle = {
  height: '100vh',
  backgroundColor: '#f9fafb',
  display: 'flex',
  fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
};

export const sidebarStyle = {
  width: '320px',
  backgroundColor: 'white',
  borderRight: '1px solid #e5e7eb',
  display: 'flex',
  flexDirection: 'column'
};

export const headerStyle = {
  padding: '16px',
  borderBottom: '1px solid #e5e7eb'
};

export const buttonStyle = (isActive, bgColor, hoverColor) => ({
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '8px',
  padding: '8px 16px',
  borderRadius: '8px',
  fontWeight: '500',
  border: 'none',
  cursor: isActive ? 'not-allowed' : 'pointer',
  backgroundColor: isActive ? '#f3f4f6' : bgColor,
  color: isActive ? '#9ca3af' : 'white',
  transition: 'all 0.2s',
  marginBottom: '8px',
});

export const newChatButtonStyle = {
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '8px',
  padding: '8px 16px',
  borderRadius: '8px',
  fontWeight: '500',
  border: '1px solid #d1d5db',
  cursor: 'pointer',
  backgroundColor: 'white',
  color: '#374151',
  transition: 'all 0.2s',
  marginBottom: '8px',
};

export const uploadSidebarButtonStyle = (isUploading) => ({
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '8px',
  padding: '8px 16px',
  borderRadius: '8px',
  fontWeight: '500',
  border: '1px solid #d1d5db',
  cursor: isUploading ? 'not-allowed' : 'pointer',
  backgroundColor: isUploading ? '#f3f4f6' : 'white',
  color: isUploading ? '#9ca3af' : '#374151',
  transition: 'all 0.2s',
  marginBottom: '8px',
});

export const statusStyle = {
  padding: '16px',
  borderBottom: '1px solid #e5e7eb'
};

export const visualizationStyle = {
  padding: '24px',
  flex: 1,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
};

export const micContainerStyle = (isSpeaking, isListening, isUploading, isTyping) => ({
  width: '96px',
  height: '96px',
  borderRadius: '50%',
  border: `4px solid ${isSpeaking ? '#ef4444' : isListening ? '#10b981' : isUploading ? '#9d174d' : isTyping ? '#fbbf24' : '#3b82f6'}`,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: isSpeaking ? '#fef2f2' : isListening ? '#f0fdf4' : isUploading ? '#fdf2f8' : isTyping ? '#fffbeb' : '#eff6ff',
  animation: (isListening || isSpeaking || isUploading || isTyping) ? 'pulse 1s infinite' : 'none',
  marginBottom: '16px'
});

export const chatAreaStyle = {
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: 'white'
};

export const chatHeaderStyle = {
  padding: '16px',
  borderBottom: '1px solid #e5e7eb',
  backgroundColor: 'white'
};

export const messagesStyle = {
  flex: 1,
  overflowY: 'auto',
  padding: '16px',
  display: 'flex',
  flexDirection: 'column',
  gap: '16px'
};

export const inputAreaStyle = {
  padding: '16px',
  borderTop: '1px solid #e5e7eb',
  backgroundColor: 'white'
};

export const inputContainerStyle = {
  display: 'flex',
  gap: '12px'
};

export const textInputStyle = {
  flex: 1,
  padding: '8px 16px',
  border: '1px solid #d1d5db',
  borderRadius: '24px',
  outline: 'none',
  fontSize: '14px'
};

export const sendButtonStyle = (textInputExists, isSpeaking, isUploading) => ({
  width: '40px',
  height: '40px',
  borderRadius: '50%',
  backgroundColor: (textInputExists && !isSpeaking && !isUploading) ? '#3b82f6' : '#d1d5db',
  border: 'none',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: (textInputExists && !isSpeaking && !isUploading) ? 'pointer' : 'not-allowed',
  transition: 'background-color 0.2s'
});

export const messageContainerStyle = (isUser) => ({
  display: 'flex',
  justifyContent: isUser ? 'flex-end' : 'flex-start'
});

export const messageContentStyle = (isUser) => ({
  display: 'flex',
  gap: '12px',
  maxWidth: '70%',
  flexDirection: isUser ? 'row-reverse' : 'row'
});

export const initialChatDisplayContainerStyle = {
  flex: 1,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
};

export const initialChatDisplayIconStyle = {
  width: '64px',
  height: '64px',
  borderRadius: '50%',
  backgroundColor: '#f3f4f6',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  margin: '0 auto 16px'
};
export const initialChatDisplayTextContainerStyle = {
  textAlign: 'center',
   h3: {
    fontSize: '18px',
    fontWeight: '600',
    color: '#111827',
    margin: '0 0 8px 0'
  },
  p: {
    color: '#6b7280',
    maxWidth: '400px',
    margin: 0,
    lineHeight: '1.5'
  }
};